"use client";

import { useEffect, useState } from "react";

import { TriggerLoggedInModalWindow } from "@/components/shared/is-logged-in";
import { Button } from "@/components/ui/button";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

export const FeedLoginWall = () => {
  const [visible, setVisible] = useState(false);

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isIntersecting) {
      setVisible(true);
    }
  }, [isIntersecting]);

  return (
    <div
      ref={ref}
      className="flex w-full flex-col items-center justify-center border-t p-6"
    >
      <div
        className={`
          w-full
          ${visible ? "opacity-100" : "opacity-0"}
        `}
      >
        <div className="rounded-lg border bg-accent p-8 text-center">
          <h3
            className="
              mb-4 text-center font-sans text-xl font-semibold
              text-muted-foreground
            "
          >
            Sign up for Focus to read more.
          </h3>
          <p className="mx-auto mb-6 w-4/5 text-center text-balance text-muted">
            Sign up or log in to engage & monetize your content, without limits.
          </p>

          <TriggerLoggedInModalWindow>
            <Button variant="default">Create or Import Wallet</Button>
          </TriggerLoggedInModalWindow>
        </div>
      </div>
    </div>
  );
};
